import { set } from "lodash";

const state = () => ({
  submittedInvoiceData: null,
  invoices: [],
  invoice: null,
});

const mutations = {
  setInvoices(state, invoices) {
    state.invoices = invoices;
  },
  setInvoice(state, invoice) {
    state.invoice = invoice;
  },
  setSubmittedInvoiceData(state, data) {
    state.submittedInvoiceData = data;
  },
};

const actions = {
  async getInvoices({ commit }, params) {
    const query = {
      query: params.query,
      departmentId: params.departmentId,
      submittedFrom: params.submittedFrom,
      submittedTo: params.submittedTo,
      // Ascending: !!params.ascending,
      pageNum: params.page,
      pageSize: params.limit,
    };
    try {
      console.log('getInvoices, params', params);
      const response = await this.$axios.get('/Invoices', { params: query });
      return response;
    } catch (err) {
      this.$defaultResponseController(err);
      throw new Error(err);
    }
  },
  async getAllInvoices({ commit }, params) {
    const query = {
      query: params.query,
      departmentId: params.departmentId,
      submittedFrom: params.submittedFrom,
      submittedTo: params.submittedTo,
      // Ascending: !!params.ascending,
      pageNum: params.page,
      pageSize: params.limit,
    };
    try {
      console.log('getAllInvoices, params', params);
      const response = await this.$axios.get('/Invoices', { params: query });
      return response;
    } catch (err) {
      this.$defaultResponseController(err);
      throw new Error(err);
    }
  },
  async getInvoice({ commit }, uuid) {
    let endpoint = '/Invoices';
    if (uuid) {
      endpoint += `/${uuid}`;
    }

    const fromCache = this.$sCache.get(`invoice-${uuid}`);
    if (fromCache) {
      commit('setInvoice', fromCache);
      return fromCache;
    }

    try {
      const response = await this.$axios.get(endpoint);
    
      if (response.data) {
        commit('setInvoice', response.data);
        this.$sCache.set(`invoice-${uuid}`, response.data, 'fiveminutes');
      } else {
        commit('setInvoice', []);
      }
      return response;
    } catch (err) {
      this.$defaultResponseController(err);
      throw new Error(err);
    }
  },
  async submitInvoice({ commit }, formData) {
    console.log('submitInvoice, formData', formData);
    try {
      const data = await this.$axios.post('/Invoices',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      commit('setSubmittedInvoiceData', data.data);
      return data;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },
  async downloadInvoice({ commit }, params) {
    try {
      const response = await this.$axios.get(`Invoices/signedurl/${params.confirmationNumber}/${params.fileName}`);
      const link = document.createElement('a');
      link.href = response.data;
      link.setAttribute('download', params.fileName); //or any other extension
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    
      return response;
    } catch (err) {
      this.$defaultResponseController(err);
      throw new Error(err);
    }
  },
};

export default {
  namespaced: true,
  state: state(),
  mutations,
  actions,
};
